import { PureComponent, Component } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { isBrowser, isTablet } from 'react-device-detect';
import { bindActionCreators } from 'redux';
import { Button, Icon, Modal, Segment } from 'semantic-ui-react';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';

import { CustomTable } from '../../../../components';

import {
  postIndustry,
  updateIndustry,
  getIndustryAll,
} from '../../../../store/actions';

import addIcon from '../../../../assets/add-icon.svg';

export default class IndustrySectorTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  async componentDidMount() {
    const { getIndustryAll } = this.props;
    getIndustryAll();
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }
  render() {
    const { modal } = this.state;
    const { t } = this.props;
    return (
      <div>
        <div className="outcome-admin-padded">
          <div className="button-outcome">
            <Modal
              open={modal}
              onOpen={() => this.toggle()}
              closeIcon={
                <Icon
                  onClick={() => this.toggle()}
                  name="close"
                  className="closeicon"
                />
              }
              size="small"
              trigger={
                <Button className="Primary-Button">
                  <div className="add-icon-activity-add">
                    <img className="icons-add" src={addIcon} alt="icon" />
                    <div className="add-text">
                      {t(
                        'admin.system_settings.industry_sector_types.add_industry_sector_type'
                      )}
                    </div>
                  </div>
                </Button>
              }
              className="create-industry-sector-type"
            >
              <Modal.Header>
                {t(
                  'admin.system_settings.industry_sector_types.create_industry_sector_type'
                )}
              </Modal.Header>
              <Modal.Content>
                <CreateIndustrySector
                  toggle={() => this.toggle()}
                  {...this.props}
                  t={t}
                />
              </Modal.Content>
            </Modal>
          </div>
        </div>
        <div className="industry-list-container">
          <IndustryList {...this.props} />
        </div>
      </div>
    );
  }
}
class CreateIndustrySector extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  async handleValidSubmit(event, values) {
    try {
      const { postIndustry, toggle } = this.props;
      await postIndustry(values);
      toggle();
    } catch (error) {
      console.error('Industry create submit ~~', error);
    }
  }
  render() {
    const { toggle, industryLoading } = this.props;
    const { t } = this.props;
    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="venue-form"
      >
        <AvField
          label={t('formulary.title')}
          className="org-inputs"
          name="name"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.title_required'),
            },
          }}
        />

        <AvField
          label={t(
            'admin.system_settings.industry_sector_types.sector_type_description'
          )}
          className="org-inputs-textarea"
          name="description"
          type="textarea"
          validate={{
            required: {
              value: true,
              errorMessage: t(
                'admin.system_settings.industry_sector_types.sector_type_description_required'
              ),
            },
          }}
        />

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.create')}
            type="submit"
            className="Primary-Button"
            loading={industryLoading}
            disabled={industryLoading}
          />
        </div>
      </AvForm>
    );
  }
}

class EditIndustryModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        name: '',
        description: '',
      },
    };
  }

  editSelectedQuestion(form) {
    this.setState({
      form,
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }
  render() {
    const { modal, form } = this.state;
    const { t, item } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <label
            className="activity-actions-warn mb-0"
            onClick={() => this.editSelectedQuestion(item)}
          >
            {t('actions.edit')}
          </label>
        }
      >
        <Modal.Header>
          {t(
            'admin.system_settings.industry_sector_types.edit_industry_sector_type'
          )}
        </Modal.Header>
        <Modal.Content>
          <EditIndustryForm
            form={form}
            toggle={() => this.toggle()}
            {...this.props}
            t={t}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

class IndustryListBase extends PureComponent {
  constructor(props) {
    super(props);
    const { t, i18n } = this.props;

    this.state = {
      columns: [
        {
          title: t('common.name'),
          render: (data) => {
            return <div className="venue-name">{data.name}</div>;
          },
          textAlign: isBrowser || isTablet ? 'left' : null,
          width: 9,
        },
        {
          title: t('common.created_date'),
          render: (data) => {
            return (
              <div>
                {new Intl.DateTimeFormat(i18n.language, {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
                }).format(new Date(data.createdAt))}
              </div>
            );
          },
          width: 3,
        },
        {
          title: t('common.updated_date'),
          render: (data) => {
            return (
              <div>
                {new Intl.DateTimeFormat(i18n.language, {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
                }).format(new Date(data.updatedAt))}
              </div>
            );
          },
          width: 3,
        },
        {
          title: <div></div>,
          render: (data) => {
            return (
              <div className="align-left">
                <EditIndustryModal
                  item={data}
                  {...this.props}
                  {...this.props}
                />
              </div>
            );
          },
          textAlign: isBrowser || isTablet ? 'right' : null,
          width: 1,
        },
      ],
      currentPage: 1,
    };
  }

  async componentDidMount() {
    try {
      const { currentPage } = this.state;
      const { getIndustryAll } = this.props;
      await getIndustryAll(currentPage);
    } catch (error) {}
  }

  pageChange(page) {
    const { getIndustryAll } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        getIndustryAll(page);
      }
    );
  }

  render() {
    const { industryAll, getIndustryAllLoading } = this.props;
    const { columns, currentPage } = this.state;
    return (
      <Segment
        className="content-segment"
        loading={getIndustryAllLoading}
        disabled={getIndustryAllLoading}
      >
        <CustomTable
          header
          columns={columns}
          data={industryAll.docs}
          pagination
          customClass="super-admin-table tbody-hover"
          handlePaginationChange={(page) => this.pageChange(page)}
          page={currentPage}
          noOfPages={industryAll.pages}
          keyExtractor={(item, index) => item.id}
        />
      </Segment>
    );
  }
}

const IndustryList = withTranslation()(IndustryListBase);

class EditIndustryForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async onValidSubmit(event, values) {
    try {
      const { updateIndustry, form, toggle } = this.props;
      await updateIndustry(form.id, values);
      toggle();
    } catch (error) {
      // handle error here
    }
  }

  render() {
    const { toggle, form, industryLoading } = this.props;
    const { t } = this.props;

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.onValidSubmit(event, values)}
        className="venue-form"
        model={form}
      >
        <AvField
          label={t('formulary.title')}
          className="org-inputs"
          name="name"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.title_required'),
            },
          }}
        />

        <AvField
          label={t('common.description')}
          className="org-inputs-textarea"
          name="description"
          type="textarea"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.description_required'),
            },
          }}
        />

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.save')}
            type="submit"
            className="Primary-Button"
            loading={industryLoading}
            disabled={industryLoading}
          />
        </div>
      </AvForm>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    industrySectorTypes: state.extra.industrySectorTypes,
    industryLoading: state.admin.industryLoading,
    industryAll: state.admin.industryAll,
    getIndustryAllLoading: state.admin.getIndustryAllLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      postIndustry,
      updateIndustry,
      getIndustryAll,
    },
    dispatch
  );
};

IndustrySectorTypes = connect(
  mapStateToProps,
  mapDispatchToProps
)(IndustrySectorTypes);

// Wrap with translation HOC
const IndustrySectorTypesWithTranslation = (props) => {
  const { t } = useTranslation();
  return <IndustrySectorTypes {...props} t={t} />;
};

export { IndustrySectorTypesWithTranslation as IndustrySectorTypes };
